export const ADD_PAYMENT_MODAL_SETTINGS = {
  panelClass: 'no-radius-dialog',
  disableClose: false,
  autoFocus: false,
  width: '600px',
};
